import { useState, useEffect } from 'preact/hooks';
import { calendarEventsApi } from '@/api/calendarEvents';
import { useToast } from '@/hooks/useToast';
export function useCalendarEvents(workspaceId, campaignId, webId) {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { showError, showErrorUnless422 } = useToast();
    const fetchEvents = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = webId
                ? await calendarEventsApi.getWebEvents(workspaceId, webId)
                : campaignId
                    ? await calendarEventsApi.getCampaignEvents(workspaceId, campaignId)
                    : await calendarEventsApi.getWorkspaceEvents(workspaceId);
            if (response.error) {
                setError(response.error);
                showErrorUnless422('Failed to load calendar', response);
                setEvents([]);
            }
            else {
                const calendarEvents = response.data || [];
                setEvents(calendarEvents);
            }
        }
        catch (err) {
            console.error('Error in fetchEvents:', err);
            const message = err instanceof Error ? err.message : 'An unexpected error occurred';
            setError(message);
            showError('Error', message);
            setEvents([]);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchEvents();
    }, [workspaceId, campaignId, webId]);
    return {
        events,
        setEvents,
        loading,
        error,
        refetch: fetchEvents,
    };
}
